import { useEffect, useState } from 'react';
import './EnsinoFundamental2.css';

import Header from '../../../../componentes/js/Header';
import Footer from '../../../../componentes/js/Footer';
import Modal from '../../../../componentes/js/Modal';
import CabecalhoSection from './secoes/CabecalhoSection';
import AtividadesSection from './secoes/AtividadesSection';
import CalendarioSection from './secoes/CalendarioSection';
import LivrosSection from './secoes/LivrosSection';
import MateriaisSection from './secoes/MateriaisSection';

function EnsinoFundamental2() {
  const [activeCard, setActiveCard] = useState(null);
  const [livros, setLivros] = useState([]);
  const timestamp = new Date().getTime();
  const [isMobile, setIsMobile] = useState(false);

  const materiais = [
    {
      ano: "6º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund2/materiais6Ano.pdf"
    },
    {
      ano: "7º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund2/materiais7Ano.pdf"
    },
    {
      ano: "8º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund2/materiais8Ano.pdf"
    },
    {
      ano: "9º Ano",
      pdfUrl: "assets/pdf/listaMateriais/fund2/materiais9Ano.pdf"
    },
  ];

  const steps = [
    {
      number: 1,
      color: "#ff9800",
      title: (
        <>
          Acesse o link:{" "}
          <a
            href="https://educarlivros.com/escola"
            style={{color:"#ff7700ff"}}
            target="_blank"
            rel="noopener noreferrer"
          >
            educarlivros.com/escola
          </a>
        </>
      ),
      description: (
        <>
          Informe o código da lista, fornecido pela Escola.{" "}
          <strong>Código: GO-0033</strong>
        </>
      ),
      logo: {
        url: "assets/images/logo/colegio-lider.png",
        text: "Disponibilizado pelo Colégio Líder",
      },
      icon: "https://cdn-icons-png.flaticon.com/512/841/841364.png",
    },
    {
      number: 2,
      color: "#f44336",
      title: "Selecione a sua lista e identifique-se",
      description:
        "Faça sua identificação ou efetue um novo cadastro. O cadastramento permite acompanhar a situação de seus pedidos e efetuar novas compras.",
      icon: "https://cdn-icons-png.flaticon.com/512/1077/1077012.png",
    },
    {
      number: 3,
      color: "#2196f3",
      title: "Adicione a lista ao carrinho",
      description:
        "Ao adicionar a lista ao carrinho será solicitado que informe o nome do aluno.",
      icon: "https://cdn-icons-png.flaticon.com/512/1170/1170678.png",
    },
    {
      number: 4,
      color: "#9c27b0",
      title: "Pagamento e Entrega",
      description:
        "Selecione o tipo de entrega: Receber em casa (cobrado frete) ou Receber na escola (frete grátis). Disponibilizamos três formas de pagamento: boleto bancário, pix e cartão de crédito.",
      icon: "https://cdn-icons-png.flaticon.com/512/126/126509.png",
    },
    {
      number: 5,
      color: "#8bc34a",
      title: "Confirmação do pedido",
      description:
        "Pedido realizado com sucesso. Você também receberá por e-mail a confirmação do pedido.",
      icon: "https://cdn-icons-png.flaticon.com/512/845/845646.png",
    },
  ];

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
    
    fetch('https://server-colegiolider.onrender.com/api/livros/fundamental-2')
      .then(response => {
        if (!response.ok) {
          console.error('Erro ao buscar dados:', response.statusText);
          throw new Error('Erro ao buscar dados');
        }
        return response.json();
      })
      .then(data => {
        setLivros(data);
      })
      .catch(error => {
        console.error('Erro:', error);
      });
  }, []);

  const cardContents = {
    'Jogos': {
      title: 'Jogos Internos',
      text: 'Os jogos internos promovem o trabalho em equipe e a colaboração. Ao participar de atividades esportivas e desafios em grupo, os alunos aprendem a importância de trabalhar juntos para alcançar objetivos comuns. Essas experiências ajudam a fortalecer habilidades de comunicação, liderança e resolução de problemas, que são cruciais tanto no ambiente acadêmico quanto no mercado de trabalho.',
      imageUrl: 'assets/images/jogos-internos.png',
    },
    'Aulas': {
      title: 'Aulas Práticas',
      text: 'Essencialmente, as aulas práticas funcionam como um laboratório que prepara os alunos para o mundo real. Elas estimulam a curiosidade, a criatividade e a capacidade de resolver problemas complexos, habilidades valiosas para qualquer carreira. Integrar essas práticas ao currículo garante que nossos jovens estejam prontos para contribuir de maneira significativa e responsável em qualquer área que escolherem.',
      imageUrl: 'assets/images/cerebro-maker.jpg',
    },
    'CNA': {
      title: 'CNA Inglês',
      text: 'Aqui, nós apoiamos o seu aprendizado de forma leve, divertida e personalizada. Você conversa com o mundo enquanto nós imaginamos um futuro cheio de possibilidades junto com você. No CNA, você pode acreditar!',
      videoUrl: 'https://www.youtube.com/embed/EF2CTjsamiI?vq=hd1080',
    },
    'SEE': {
      title: 'SEE',
      text: 'O Programa de Socioemocional e Ética (PSEE) é o processo pelo qual crianças, jovens e adultos adquirem e aplicam o conhecimento, as habilidades e atitudes para desenvolverem identidades  saudáveis, gerenciar emoções, alcançar metas pessoais e coletivas, sentir e demonstrar empatia pelos outros, estabelecer e manter relações solidárias bem como tomar decisões responsáveis, cuidadosas e orientadas por valores éticos.',
      imageUrl: 'assets/images/see.png',
    }
  };

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
        <Header />
    <main>
    <div className="escola">
      <CabecalhoSection />

      <AtividadesSection onSelectCard={setActiveCard} />

      <CalendarioSection timestamp={timestamp} />

      <Modal
          show={!!activeCard}
          onClose={() => setActiveCard(null)}
          title={cardContents[activeCard]?.title}
          text={cardContents[activeCard]?.text}
          imageUrl={cardContents[activeCard]?.imageUrl}
          videoUrl={cardContents[activeCard]?.videoUrl}
      />

      <LivrosSection steps={steps} livros={livros} />
      <MateriaisSection materiais={materiais} />
    </div>
    </main>
    <Footer />
    </div>
  );
}

export default EnsinoFundamental2;
